/* fourpaw-standard: lifecycle-delegated */
(() => {
  if (window.SafeWalkV8GiftPackEditor) return;

  const copy = () => window.SafeWalkV8GiftPackEditorCopy || {};
  const lifecycle = () => window.SafeWalkV8GiftPackLifecycle;
  const propertiesFor = (item) => item?.properties && typeof item.properties === 'object'
    ? item.properties
    : {};
  const shouldAutoFocus = () => window.matchMedia?.(
    '(min-width: 750px) and (hover: hover) and (pointer: fine)'
  ).matches;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const validationKey = ({ phone } = {}) => {
    const normalized = String(phone || '').trim();
    if (!normalized) return '';
    const digits = normalized.replace(/\D/g, '');
    return digits.length >= 7 && digits.length <= 15 ? '' : 'phoneError';
  };
  const editorFor = (target) => target?.closest('.fp-cart-gift-group')
    ?.querySelector('[data-safewalk-gift-pack-editor]');
  const triggerFor = (editor) => editor?.closest('.fp-cart-gift-group')
    ?.querySelector('[data-safewalk-gift-pack-edit]');
  const messageFor = (editor) => editor?.closest('.fp-cart-gift-group')
    ?.querySelector('[data-safewalk-gift-pack-message]');
  const setMessage = (editor, message, state = '') => {
    const node = messageFor(editor);
    if (!node) return;
    node.textContent = message || '';
    if (message && state) node.dataset.safewalkMessageState = state;
    else delete node.dataset.safewalkMessageState;
  };
  const buildEditor = (editor) => {
    if (editor.childElementCount) return;
    const fields = make('div', 'fp-cart-gift-group__editor-fields');
    [
      ['dog', copy().dogNameLabel, editor.dataset.safewalkDogName, 40],
      ['phone', copy().phoneLabel, editor.dataset.safewalkPhone, 20]
    ].forEach(([kind, labelText, value, maxLength]) => {
      const label = make('label', 'fp-cart-gift-group__field');
      label.append(make('span', '', labelText));
      const input = document.createElement('input');
      input.dataset.safewalkGiftPackInput = kind;
      input.value = value || '';
      input.maxLength = maxLength;
      if (kind === 'phone') {
        input.type = 'tel';
        input.inputMode = 'tel';
        input.autocomplete = 'tel';
        input.dir = 'ltr';
      }
      label.append(input);
      fields.append(label);
    });
    editor.append(fields, make('p', 'fp-cart-gift-group__helper', copy().helper));
    const actions = make('div', 'fp-cart-gift-group__editor-actions');
    const save = make('button', 'fp-cart-gift-group__save', copy().save);
    save.type = 'button';
    save.dataset.safewalkGiftPackSave = '';
    const cancel = make('button', 'fp-cart-gift-group__cancel', copy().cancel);
    cancel.type = 'button';
    cancel.dataset.safewalkGiftPackCancel = '';
    actions.append(save, cancel);
    editor.append(actions);
  };
  const resetEditor = (editor) => {
    if (!editor) return;
    const values = {
      dog: editor.dataset.safewalkDogName || '',
      phone: editor.dataset.safewalkPhone || ''
    };
    editor.querySelectorAll('[data-safewalk-gift-pack-input]').forEach((input) => {
      input.value = values[input.dataset.safewalkGiftPackInput] || '';
      input.removeAttribute('aria-invalid');
    });
    const save = editor.querySelector('[data-safewalk-gift-pack-save]');
    if (save) {
      save.disabled = false;
      save.textContent = copy().save;
    }
    editor.removeAttribute('aria-busy');
    setMessage(editor, '');
  };
  const closeEditor = (editor, restoreFocus = true) => {
    if (!editor) return;
    editor.hidden = true;
    const trigger = triggerFor(editor);
    trigger?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) trigger?.focus();
  };
  const readCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`cart-${response.status}`);
    return response.json();
  };
  const sectionIds = () => {
    const ids = new Set(['cart-drawer', 'cart-icon-bubble']);
    document.querySelectorAll(
      '[data-safewalk-gift-pack-section][data-section-id], cart-items[data-id], #main-cart-footer[data-id]'
    ).forEach((node) => ids.add(node.dataset.sectionId || node.dataset.id));
    document.querySelector('cart-drawer')?.getSectionsToRender?.()
      .forEach((section) => ids.add(section.id));
    return [...ids].filter(Boolean).slice(0, 5);
  };
  const changeLine = async (item, properties) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: Number(item.quantity || 1),
        properties,
        sections: sectionIds(),
        sections_url: window.location.pathname
      })
    });
    const body = await response.json().catch(() => null);
    if (!response.ok || !body) throw new Error(`change-${response.status}`);
    return body;
  };
  const replaceSection = (sectionId, html) => {
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const current = document.getElementById(`shopify-section-${sectionId}`)
      || document.getElementById(sectionId);
    const fresh = parsed.getElementById(`shopify-section-${sectionId}`)
      || parsed.getElementById(sectionId);
    if (current && fresh) current.innerHTML = fresh.innerHTML;
  };
  const render = (body) => {
    if (!body?.sections) return;
    const drawer = document.querySelector('cart-drawer');
    if (drawer?.renderContents && body.sections['cart-drawer']) {
      drawer.classList.remove('is-empty');
      drawer.renderContents(body);
    }
    Object.entries(body.sections).forEach(([id, html]) => {
      if (id !== 'cart-drawer' && id !== 'cart-icon-bubble') replaceSection(id, html);
    });
    lifecycle()?.schedule?.();
  };
  const personalizedProperties = (existing, personalization) => {
    const result = { ...existing };
    const dogKey = copy().dogNameProperty || 'שם הכלב';
    const phoneKey = copy().phoneProperty || 'מספר טלפון';
    ['שם הכלב', 'מספר טלפון', dogKey, phoneKey].forEach((key) => delete result[key]);
    const dogName = String(personalization.dogName || '').trim();
    const phone = String(personalization.phone || '').trim();
    if (dogName) result[dogKey] = dogName;
    if (phone) result[phoneKey] = phone;
    return result;
  };
  const groupForId = (cart, groupId) => lifecycle()?.classify?.(cart)?.groups?.find((group) => (
    String(lifecycle()?.metadataFor?.(group.main)?.id || '') === String(groupId)
  ));
  const valuesMatch = (item, target) => {
    const properties = propertiesFor(item);
    const dogKey = copy().dogNameProperty || 'שם הכלב';
    const phoneKey = copy().phoneProperty || 'מספר טלפון';
    return String(properties[dogKey] || '') === String(target[dogKey] || '')
      && String(properties[phoneKey] || '') === String(target[phoneKey] || '');
  };
  const savePersonalization = async (lineKey, personalization) => {
    let cart = await readCart();
    const main = cart.items.find((item) => String(item.key) === String(lineKey));
    const groupId = lifecycle()?.metadataFor?.(main)?.id;
    const state = lifecycle()?.classify?.(cart);
    const group = state?.groups?.find((entry) => entry.main === main);
    if (!main || !groupId || !group?.complete || Number(main.final_line_price) <= 0) {
      throw new Error('main-line');
    }
    const previous = { ...propertiesFor(main) };
    const next = personalizedProperties(previous, personalization);
    const body = await changeLine(main, next);
    cart = await readCart();
    const savedGroup = groupForId(cart, groupId);
    if (!savedGroup?.complete || !valuesMatch(savedGroup.main, next)) {
      try {
        const current = groupForId(cart, groupId)?.main;
        if (current) await changeLine(current, previous);
      } catch (_) { /* Keep the visible error; lifecycle blocks an invalid cart. */ }
      throw new Error('verification');
    }
    render(body);
    return savedGroup.main.key;
  };

  document.addEventListener('click', async (event) => {
    const edit = event.target.closest?.('[data-safewalk-gift-pack-edit]');
    if (edit) {
      const editor = editorFor(edit);
      if (!editor) return;
      document.querySelectorAll('[data-safewalk-gift-pack-editor]:not([hidden])')
        .forEach((open) => closeEditor(open, false));
      buildEditor(editor);
      resetEditor(editor);
      editor.hidden = false;
      edit.setAttribute('aria-expanded', 'true');
      if (shouldAutoFocus()) editor.querySelector('input')?.focus();
      return;
    }
    const cancel = event.target.closest?.('[data-safewalk-gift-pack-cancel]');
    if (cancel) {
      const editor = editorFor(cancel);
      resetEditor(editor);
      closeEditor(editor);
      return;
    }
    const save = event.target.closest?.('[data-safewalk-gift-pack-save]');
    if (!save) return;
    const editor = editorFor(save);
    const personalization = {
      dogName: editor?.querySelector('[data-safewalk-gift-pack-input="dog"]')?.value || '',
      phone: editor?.querySelector('[data-safewalk-gift-pack-input="phone"]')?.value || ''
    };
    const errorKey = validationKey(personalization);
    if (!editor || errorKey) {
      setMessage(editor, copy()[errorKey] || copy().validation, 'error');
      const phone = editor?.querySelector('[data-safewalk-gift-pack-input="phone"]');
      phone?.setAttribute('aria-invalid', 'true');
      phone?.focus();
      return;
    }
    save.disabled = true;
    save.textContent = copy().saving;
    editor.setAttribute('aria-busy', 'true');
    try {
      const savedKey = await savePersonalization(editor.dataset.safewalkCartLineKey, personalization);
      const freshEditor = document.querySelector(
        `[data-safewalk-gift-pack-editor][data-safewalk-cart-line-key="${CSS.escape(savedKey)}"]`
      );
      const fresh = triggerFor(freshEditor);
      fresh?.focus();
      const message = fresh?.closest('.fp-cart-gift-group')
        ?.querySelector('[data-safewalk-gift-pack-message]');
      if (message) {
        message.textContent = copy().success;
        message.dataset.safewalkMessageState = 'success';
      }
    } catch (_) {
      save.disabled = false;
      save.textContent = copy().save;
      editor.removeAttribute('aria-busy');
      setMessage(editor, copy().networkError, 'error');
      lifecycle()?.schedule?.();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeEditor(
      event.target.closest?.('[data-safewalk-gift-pack-editor]')
    );
  });
  document.addEventListener('input', (event) => {
    const editor = event.target.closest?.('[data-safewalk-gift-pack-editor]');
    if (!editor) return;
    event.target.removeAttribute?.('aria-invalid');
    setMessage(editor, '');
  });

  window.SafeWalkV8GiftPackEditor = Object.freeze({
    personalizedProperties,
    savePersonalization,
    validationKey
  });
})();
